import { render, staticRenderFns } from "./LibraryCertificatesModal.vue?vue&type=template&id=5a0896c0&scoped=true"
import script from "./LibraryCertificatesModal.vue?vue&type=script&lang=ts"
export * from "./LibraryCertificatesModal.vue?vue&type=script&lang=ts"
import style0 from "./LibraryCertificatesModal.vue?vue&type=style&index=0&id=5a0896c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0896c0",
  null
  
)

export default component.exports